import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { getApiUrl } from '../config/api';

export function useConnectNotifications() {
  const [pendingInvitations, setPendingInvitations] = useState([]);
  const [connectionRequests, setConnectionRequests] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const fetchPendingInvitations = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(getApiUrl("/api/connect/invitations"), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setPendingInvitations(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      console.error("Error fetching pending invitations:", err);
      setPendingInvitations([]);
    }
  }, []);

  const fetchConnectionRequests = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(getApiUrl("/api/connect/requests"), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setConnectionRequests(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      console.error("Error fetching connection requests:", err);
      setConnectionRequests([]);
    }
  }, []);

  const fetchUnreadCount = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(getApiUrl("/api/connect/unread-count"), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUnreadCount(response.data.unreadCount || 0);
    } catch (err) {
      console.error("Error fetching unread count:", err);
      setUnreadCount(0);
    }
  }, []);

  const fetchAllNotifications = useCallback(async () => {
    setIsLoading(true);
    try {
      await Promise.all([
        fetchPendingInvitations(),
        fetchConnectionRequests(),
        fetchUnreadCount()
      ]);
    } finally {
      setIsLoading(false);
    }
  }, [fetchPendingInvitations, fetchConnectionRequests, fetchUnreadCount]);

  useEffect(() => {
    fetchAllNotifications();
  }, [fetchAllNotifications]);

  // Calculate total notification count
  const totalNotificationCount = pendingInvitations.length + connectionRequests.length + unreadCount;

  return {
    pendingInvitations,
    connectionRequests,
    unreadCount,
    totalNotificationCount,
    isLoading,
    refreshNotifications: fetchAllNotifications
  };
}
